import * as types from './Types.js';

import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import { fromJS } from 'immutable';

const initialState = fromJS({
  suspensaoFornecedores: [],
  tiposOcorrencias: []
});

function suspensaoFornecedorReducer(state = initialState, action) {
  switch (action.type) {
    case types.SUSPENSAOFORNECEDORES_LIST_START: {
      return startLoad(state);
    }

    case types.SUSPENSAOFORNECEDORES_LIST_SUCCESS: {
      return endLoad(
        state.set('suspensaoFornecedores', fromJS(action.payload))
      );
    }

    case types.SUSPENSAOFORNECEDORES_LIST_ERROR: {
      return endLoad(state);
    }

    case types.TIPOSOCORRENCIAS_LIST_START: {
      return startLoad(state);
    }
    case types.TIPOSOCORRENCIAS_LIST_SUCCESS: {
      return endLoad(state.set('tiposOcorrencias', fromJS(action.payload)));
    }
    case types.TIPOSOCORRENCIAS_LIST_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default suspensaoFornecedorReducer;
